import { useEffect } from 'react';
import { useCanvasStore } from '../stores/canvasStore.js';

export const useCanvasKeyboardShortcuts = () => {
  const activeCanvas = useCanvasStore((state) => state.getActiveCanvas());
  const updateGridSettings = useCanvasStore((state) => state.updateGridSettings);

  useEffect(() => {
    if (!activeCanvas || activeCanvas.kind === 'market') {
      return;
    }

    const handleKeyPress = (e: KeyboardEvent) => {
      // Delete selected widget(s)
      if (e.key === 'Delete' || e.key === 'Backspace') {
        // TODO: Implement widget selection state
        // For now, this is a placeholder
        console.log('Delete key pressed');
      }

      // Toggle grid (Cmd/Ctrl + G)
      if ((e.metaKey || e.ctrlKey) && e.key === 'g') {
        e.preventDefault();
        updateGridSettings(activeCanvas.id, {
          enabled: !activeCanvas.gridSettings.enabled,
        });
      }

      // Duplicate widget (Cmd/Ctrl + D)
      if ((e.metaKey || e.ctrlKey) && e.key === 'd') {
        e.preventDefault();
        // TODO: Implement widget duplication
        console.log('Duplicate shortcut pressed');
      }

      // Save layout (Cmd/Ctrl + S)
      if ((e.metaKey || e.ctrlKey) && e.key === 's') {
        e.preventDefault();
        // TODO: Implement layout save dialog
        console.log('Save shortcut pressed');
      }

      // Undo (Cmd/Ctrl + Z)
      if ((e.metaKey || e.ctrlKey) && e.key === 'z' && !e.shiftKey) {
        e.preventDefault();
        // TODO: Implement undo functionality
        console.log('Undo shortcut pressed');
      }

      // Redo (Cmd/Ctrl + Shift + Z)
      if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.key === 'z') {
        e.preventDefault();
        // TODO: Implement redo functionality
        console.log('Redo shortcut pressed');
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [activeCanvas, updateGridSettings]);
};
